import React from 'react';

const EditTeamModal = ({
  editingTeam,
  setEditingTeam,
  editTeamForm,
  setEditTeamForm,
  assignableUsers = [],
  user,
  handleEditTeam,
  isLoading,
}) => {
  if (!editingTeam) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-xs flex items-center justify-center z-50 p-4">
      <div className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden text-slate-800 animate-fadeIn">
        <div className="p-4 px-5 border-b border-slate-100 bg-blue-600 text-white flex items-center justify-between">
          <h3 className="text-base font-bold">Edit Team</h3>
          <button
            onClick={() => setEditingTeam(null)}
            className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-xs"
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleEditTeam} className="p-5 space-y-4 text-xs">
          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">Team Name</label>
            <input
              type="text"
              required
              className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2.5 text-slate-800 focus:outline-none"
              value={editTeamForm.name}
              onChange={(e) => setEditTeamForm({ ...editTeamForm, name: e.target.value })}
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">Description</label>
            <textarea
              required
              rows={3}
              className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2.5 text-slate-800 focus:outline-none"
              value={editTeamForm.description}
              onChange={(e) => setEditTeamForm({ ...editTeamForm, description: e.target.value })}
            />
          </div>

          {(user?.role === 'admin' || user?.role === 'superadmin') && (
            <div>
              <label className="block text-xs font-semibold text-slate-700 mb-1.5">Team Manager</label>
              <select
                required
                className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2.5 text-slate-800 focus:outline-none"
                value={editTeamForm.manager_id}
                onChange={(e) => setEditTeamForm({ ...editTeamForm, manager_id: e.target.value })}
              >
                <option value="">Select Manager</option>
                {assignableUsers.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.username}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="flex justify-end gap-2.5 pt-3 border-t border-slate-100">
            <button
              type="button"
              onClick={() => {
                setEditingTeam(null);
                setEditTeamForm({ name: '', description: '', manager_id: '' });
              }}
              className="px-4 py-2 text-xs font-bold text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="px-4 py-2 text-xs font-bold text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 rounded-xl shadow-xs disabled:opacity-50 transition-all"
            >
              {isLoading ? 'Updating...' : 'Update Team'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTeamModal;
